import { InfoCircleOutlined } from '@ant-design/icons';

import { mutedTextStyle } from './muted-text-style';

const preventDefault = (e) => e.preventDefault();

/**
 * Kartı ortak gruba yalnız Telif Sonrası'ndaki maddelerin eklenebileceğini söyleyen, açılır listenin başındaki satır.
 * Hem grubun madde ekleme kutusunda hem madde detayındaki grup seçiminde kullanılır. Tıklama input'un odağını almaz,
 * liste açık kalır.
 */
function PostOrderOnlyNotice() {
  return (
    <div
      className="gx-d-flex gx-align-items-start"
      style={{
        ...mutedTextStyle,
        gap: 8,
        padding: '6px 12px 8px',
        borderBottom: '1px solid #F0F2F1',
      }}
      onMouseDown={preventDefault}
    >
      <InfoCircleOutlined style={{ marginTop: 3 }} />
      <span>Bu grubun kimlik kartı ortak. Yalnız Telif Sonrası&apos;ndaki maddeler eklenebilir.</span>
    </div>
  );
}

export default PostOrderOnlyNotice;
